import React, { createContext, useContext, useState, ReactNode } from 'react';
import { menuItem,TypeToCategoria } from "../helpers/interfaces";

export interface TypeCategory {
  categoria: string | null,
  label: string
}

interface MenuSingletonContextType {
  // definisci le proprietà del contesto
  menu: any;
  updateMenu: (val: any) => void;
  getMenu: () => any;
  getSlugPath: (subItems: menuItem[]) => any;
  getTypeToCategoriaMap: (subItems: menuItem[]) => any;
}

const defaultContext: MenuSingletonContextType = {
  menu: {},
  updateMenu: () => { },
  getMenu: () => { },
  getSlugPath: (subItems: menuItem[]) => [],
  getTypeToCategoriaMap: (subItems: menuItem[]) => []
};

const MenuSingletonContext = createContext<MenuSingletonContextType>(defaultContext);
 
export const MenuSingletonProvider = ({ children }: { children: ReactNode }) => {
  const [menu, setMenu] = useState();

  const updateMenu = (newValue: any) => {
    setMenu(newValue);
  };

  const getTypeToCategoriaMap = (menuItems: menuItem[]): Record<string, TypeToCategoria> =>
    menuItems.reduce((acc: any, item: menuItem) => {
      acc[item.type] = {
        categoria: item.categoria,
        label: item.label,
      };

      if (item.sub && item.sub.length > 0) {
        Object.assign(acc, getTypeToCategoriaMap(item.sub));
      }
  
      return acc;
    }, {} as Record<string, TypeToCategoria>);
  

  const getMenu = () => { return menu; };
  const getSlugPath = (subItems: menuItem[], parentUrl: string = ''): any =>
    subItems.reduce((acc: any, item: menuItem) => {
      const currentUrl = item.url ? `/${item.url}` : '';
      const fullPath = parentUrl + currentUrl;

      const cleanedPath = fullPath.startsWith("/") ? fullPath.slice(1) : fullPath; // Rimuove la barra iniziale se presente
      const parts = cleanedPath.split("/");

      const key = parts[0];

      acc["_"+key+"_" + item.categoria] = fullPath;
  
      if (item.sub && item.sub.length > 0) {
        Object.assign(acc, getSlugPath(item.sub, fullPath));
      }
  
      return acc;
    }, {});
  

  return (
    <MenuSingletonContext.Provider value={{ menu, getMenu, updateMenu, getSlugPath, getTypeToCategoriaMap }}>
      {children}
    </MenuSingletonContext.Provider>
  );
};

export const useMenuSingleton = () => useContext(MenuSingletonContext);
